import { combineReducers } from 'redux';
import media, * as fromMedia from './media/reducers';
import lists, * as fromLists from './lists/reducers';
import ads, * as fromAds from './ads/reducers';

const rootReducer = combineReducers({
  media,
  lists,
  ads,
});

export default rootReducer;

export const getIsPageFetching = state =>
  state.media.isFetching || state.lists.isFetching;
export const getMediaItem = (state, slug) =>
  fromMedia.getMediaItem(state.media, slug);
export const getMediaSeries = (state, slug) =>
  fromMedia.getMediaSeries(state.media, slug);
export const getBookData = (state, slug) =>
  fromMedia.getBookData(state.media, slug);
export const getFirstVideoInSeries = (state, slug) =>
  fromMedia.getFirstVideoInSeries(state.media, slug);
export const getIsMediaFetching = state => fromMedia.getIsFetching(state.media);
export const getIsListsFetching = state => fromMedia.getIsFetching(state.lists);
export const getAdCampaign = (state, page) =>
  fromAds.getAdCampaign(state.ads, page);
export const getVideoPlayerId = state => state.ads.videoPlayer.playerId;
export const getVisibleAdSlotCount = state =>
  fromAds.getVisibleAdSlotCount(state.ads);
export const getRenderedAdSlotCount = state =>
  fromAds.getRenderedAdSlotCount(state.ads);
export const getBackgroundSkin = (state, route) =>
  fromAds.getBackgroundSkin(state.ads, route);
export const getErrorMessage = state => state.media.error || state.lists.error;
export const getErrors = state => ({
  media: state.media.error,
  lists: state.lists.error,
});

const getList = (state, listId) => {
  let list = state.lists.byId[listId];
  return {
    ...list,
    items: list.items.map(slug => state.media.byId[slug]),
  };
};

export const getHero = (state, pathname) => {
  const heroIds = state.lists.heroByPathname[pathname];
  if (!heroIds) return null;
  let hero = state.lists.byId[heroIds[0]];
  if (!hero) return null;
  return {
    ...hero,
    items: hero.items.map(slug => state.media.byId[slug]),
  };
};

export const getMediaLists = (state, pageType, pathname) => {
  const listIds = state.lists.listsByPathname[pathname];
  if (!listIds) return null;
  const listMetadata = fromLists.getListMetadata(pageType);
  return listIds.map((listId, i) => {
    const list = getList(state, listId);
    return {
      ...list,
      ...listMetadata[i],
    };
  });
};
